"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Steps = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var getCompletionStatus = function (index, currentIndex) {
    if (index === currentIndex)
        return 'active';
    if (index < currentIndex)
        return 'complete';
    return 'incomplete';
};
var Steps = function (_a) {
    var children = _a.children, activeStep = _a.activeStep, size = _a.size, _b = _a.leftAligned, leftAligned = _b === void 0 ? false : _b, _c = _a.tabbed, tabbed = _c === void 0 ? false : _c, _d = _a.showNumberOnComplete, showNumberOnComplete = _d === void 0 ? false : _d, className = _a.className;
    var convertedSize = tabbed ? undefined : size;
    var convertedChildren = react_1.default.Children.toArray(children);
    return ((0, jsx_runtime_1.jsx)("div", __assign({ className: (0, classnames_1.default)('steps d-flex', convertedSize && "steps-".concat(convertedSize), leftAligned && 'steps-alignment-left', tabbed && 'steps-tabbed', className), "aria-label": "progress", "data-testid": "steps" }, { children: convertedChildren.map(function (child, index) {
            var _a;
            return react_1.default.cloneElement(child, {
                step: index + 1,
                key: index,
                completionStatus: child.props.completionStatus || getCompletionStatus(index, activeStep),
                size: convertedSize,
                tabbed: tabbed,
                showNumberOnComplete: (_a = child.props.showNumberOnComplete) !== null && _a !== void 0 ? _a : showNumberOnComplete,
            });
        }) })));
};
exports.Steps = Steps;
